var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchNew2 = function SvgSearchNew2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.283 15.217-2.783-2.76a6.75 6.75 0 1 0-1.042 1.043l2.76 2.76a.75.75 0 0 0 1.065 0 .75.75 0 0 0 0-1.043ZM8.25 13.5a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Z",
    fill: "#666"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchNew2);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTYuMjgzIDE1LjIxNy0yLjc4My0yLjc2YTYuNzUgNi43NSAwIDEgMC0xLjA0MiAxLjA0M2wyLjc2IDIuNzZhLjc1Ljc1IDAgMCAwIDEuMDY1IDAgLjc1Ljc1IDAgMCAwIDAtMS4wNDNaTTguMjUgMTMuNWE1LjI1IDUuMjUgMCAxIDEgMC0xMC41IDUuMjUgNS4yNSAwIDAgMSAwIDEwLjVaIiBmaWxsPSIjNjY2Ii8+PC9zdmc+";